import type { AssessmentsStore } from './interfaces'

import { useDisciplineStore } from '@stores/discipline'

import { useAssessmentsApi } from '@api/assessments/index.hook'

export const actions = {
  setAssessments (this: AssessmentsStore, payload: AssessmentsStore['assessments']): void {
    this.assessments = payload
  },
  setAssessmentAutologinUrl (this: AssessmentsStore, payload: AssessmentsStore['assessmentAutologinUrl']): void {
    this.assessmentAutologinUrl = payload
  },
  setAssessmentAutologinSharedUrl (this: AssessmentsStore, payload: AssessmentsStore['assessmentAutologinSharedUrl']): void {
    this.assessmentAutologinSharedUrl = payload
  },
  refreshNow (this: AssessmentsStore): void {
    const disciplineStore = useDisciplineStore()
    if (disciplineStore.activeDiscipline) {
      void useAssessmentsApi({ disciplineId: disciplineStore.activeDiscipline?.id }).get()
    }
  },
  setLinkUpsellMath (this: AssessmentsStore, payload: AssessmentsStore['linkUpsellMath']): void {
    this.linkUpsellMath = payload
  },
  setLinkUpsellEla (this: AssessmentsStore, payload: AssessmentsStore['linkUpsellEla']): void {
    this.linkUpsellEla = payload
  },
  setClearLinksUpsell (this: AssessmentsStore): void {
    this.linkUpsellMath = null
    this.linkUpsellEla = null
  },
  setAssessmentUpsellClosed (this: AssessmentsStore, payload: AssessmentsStore['assessmentUpsellClosed']): void {
    this.assessmentUpsellClosed = payload
  },
}
